import React from 'react';
import { CheckSquare } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../context/ToastContext';
export function ApprovalsWidget() {
  const navigate = useNavigate();
  const {
    showToast
  } = useToast();
  const pendingApprovals = [{
    id: 1,
    type: 'Congé',
    employee: 'Marie Dupont',
    date: '2023-12-22 - 2023-12-31',
    requestDate: '2023-11-15'
  }, {
    id: 2,
    type: 'Congé',
    employee: 'Jean Martin',
    date: '2024-01-05 - 2024-01-12',
    requestDate: '2023-11-18'
  }, {
    id: 3,
    type: 'Évaluation',
    employee: 'Sophie Bernard',
    date: 'Q4 2023',
    requestDate: '2023-11-10'
  }];
  const handleApprove = (id: number) => {
    showToast('Demande approuvée avec succès', 'success');
  };
  const handleReject = (id: number) => {
    showToast('Demande refusée', 'info');
  };
  return <div className="bg-white rounded-lg shadow-sm p-5 col-span-2" data-id="element-1856">
      <div className="flex items-center justify-between mb-4" data-id="element-1857">
        <h3 className="font-semibold text-gray-900" data-id="element-1858">Approbations en attente</h3>
        <CheckSquare className="h-5 w-5 text-blue-600" data-id="element-1859" />
      </div>
      {pendingApprovals.length > 0 ? <div className="overflow-x-auto" data-id="element-1860">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-1861">
            <thead className="bg-gray-50" data-id="element-1862">
              <tr data-id="element-1863">
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1864">
                  Type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1865">
                  Employé
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1866">
                  Période
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1867">
                  Date demande
                </th>
                <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-1868">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-1869">
              {pendingApprovals.map(approval => <tr key={approval.id} data-id="element-1870">
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-1871">
                    {approval.type}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1872">
                    {approval.employee}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1873">
                    {approval.date}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-1874">
                    {approval.requestDate}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-1875">
                    <button onClick={() => handleApprove(approval.id)} className="text-blue-600 hover:text-blue-900 mr-3" data-id="element-1876">
                      Approuver
                    </button>
                    <button onClick={() => handleReject(approval.id)} className="text-red-600 hover:text-red-900" data-id="element-1877">
                      Refuser
                    </button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div> : <div className="text-center py-4" data-id="element-1878">
          <p className="text-gray-500" data-id="element-1879">Aucune approbation en attente</p>
        </div>}
      <div className="mt-4 text-right" data-id="element-1880">
        <button onClick={() => navigate('/manager/approbations')} className="text-blue-600 text-sm font-medium hover:text-blue-800" data-id="element-1881">
          Voir toutes les demandes
        </button>
      </div>
    </div>;
}